module.exports = __webpack_public_path__ + "02_long_gold.6aa1aee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_long_gold.png
// module id = QS5+
// module chunks = 0